import { EntityDescriptor } from '../business-logic';
import {
	FeatureFlagDocument,
	featureFlagSchema,
} from '../schemas/featureFlagSchema';

// Singleton document ID
export const FEATURE_FLAGS_DOC_ID = 'feature-flags';

export const featureFlagEntity: EntityDescriptor<FeatureFlagDocument> = {
	featureflags: {
		migrationStrategies: {
			1: function (oldDoc) {
				return {
					...oldDoc,
					devOverrides: {}, // Initialize empty dev overrides
				};
			},
		},
		schema: featureFlagSchema,
	},
};
